import axios from 'axios'
import { post } from '@/utils/request'

const PRESIGNED_PUT_PATH = process.env.NODE_ENV === 'production'
  ? '/hub/file/generatePresignedPutUrl'
  : 'https://im.api.samworkfinance.com/hub/file/generatePresignedPutUrl'

/** 去掉预签名 URL 上的查询参数，得到永久访问地址 */
export function stripUrlQuery(url) {
  return String(url || '').split('?')[0]
}

function parsePresignResponse(res) {
  const body = (res && res.data) || {}
  let payload = body.data

  if (payload === undefined || payload === null) {
    payload = body
  }

  if (typeof payload === 'string') {
    return {
      presignedUrl: payload,
      accessUrl: stripUrlQuery(payload)
    }
  }

  const presignedUrl =
    payload.presignedPutUrl ||
    payload.presignedUrl ||
    payload.putUrl ||
    payload.uploadUrl ||
    payload.url

  const accessUrl =
    payload.accessUrl ||
    payload.publicUrl ||
    payload.fileUrl ||
    payload.permanentUrl ||
    stripUrlQuery(presignedUrl)

  return { presignedUrl, accessUrl }
}

/**
 * Hub 文件上传：获取 S3 预签名 PUT 地址 → PUT 文件 → 返回永久访问 URL
 * @param {File|Blob} file
 * @returns {Promise<string>}
 */
export async function uploadHubFile(file) {
  if (!file) {
    throw new Error('上传文件不能为空')
  }

  const fileName = file.name || 'file'
  const contentType = file.type || 'application/octet-stream'

  const res = await post(PRESIGNED_PUT_PATH, {
    fileName,
    contentType
  })

  const { presignedUrl, accessUrl } = parsePresignResponse(res)
  if (!presignedUrl) {
    throw new Error('未获取到预签名上传地址')
  }

  await axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': contentType
    }
  })

  return accessUrl || stripUrlQuery(presignedUrl)
}

export default uploadHubFile
